import React, {  useEffect, useState } from 'react';
import Breadcrumb from '../../component/Breadcrumb';
import {  Grid, Typography } from '@mui/material';
import CardComponent from './CardComponent';
import UploadRoundedIcon from '@mui/icons-material/UploadRounded';
import FileDownloadRoundedIcon from '@mui/icons-material/FileDownloadRounded';
import VisibilityRoundedIcon from '@mui/icons-material/VisibilityRounded';
import DescriptionRoundedIcon from '@mui/icons-material/DescriptionRounded';
import NoteAddRoundedIcon from '@mui/icons-material/NoteAddRounded';
import ViewListRoundedIcon from '@mui/icons-material/ViewListRounded';
import { gridSpacing } from '../../config';
// import MappingDownloadTable from '../MappingFileDownload/table';
// import { fetchMappingTableData } from '../../api/mappingApi';
import Loader from '../../component/Loader/Loader';
import { fetchProjectsList } from '../../api/mappingApi';
// import { useOktaAuth } from '@okta/okta-react';
import ProjectComponent from './ProjectComponent';
import { useMsal } from "@azure/msal-react";

const data = [
    { 
        type: 'Mapping', 
        links: [
            {
                link : '/mapping/upload',
                text : 'Upload Mapping',
                icon : <UploadRoundedIcon />

            },
            {
                link : '/mapping/download',
                text : 'Download Mapping',
                icon : <FileDownloadRoundedIcon />
            },
            {
                link : '/parameters',
                text : 'Mapping Data',
                icon : <DescriptionRoundedIcon />

            }
        ]
    },
    {   
        type: 'Config', 
        links: [
            {
                link : '/config/add-project',
                text : 'Add New Project',
                icon : <UploadRoundedIcon />
    
            },
            // {
            //     link : '',
            //     text : 'Download Project File',
            //     icon : <FileDownloadRoundedIcon />
            // },
            {
                link : '/config/projects-list',
                text : 'Projects List',
                icon : <ViewListRoundedIcon />
    
            },
        ] 
    },
    { 
        type: 'Generate', 
        links: [
            {
                link : '/generate-config',
                text : 'Generate Config',
                icon : <NoteAddRoundedIcon />
            }
        ] 
    },
    { 
        type: 'View', 
        links: [
            {
                link : '/mapping/parameters',
                text : 'View Mappings',
                icon : <VisibilityRoundedIcon />
            },
        ]  
    }
];


const Dashboard = () => {
    const { instance }  = useMsal();
    const accounts      = instance.getAllAccounts();
    //console.log('accounts',accounts[0]?.username)
    //const { authState }                  = useOktaAuth();
    const [showLoader, setShowLoader]    = useState(false);
    const [projectList, setProjectList]  = useState([]);

    useEffect(() => {
        const fetchData = async () => {
        setShowLoader(true);
            // const addedBy = authState?.accessToken?.claims?.sub;
            // const addedBy = accounts[0]?.username;
            const addedBy = "adminconfig@oncueplus.onmicrosoft.com";
            const data    = await fetchProjectsList(0,5,addedBy);
            setShowLoader(false);
            setProjectList(data);
        }
        fetchData();
    },[]);

    // useEffect(() => {
    //     if(!accounts.length){
    //         setShowLoader(true);
    //     }
    // },[accounts]);
    
    return (
        <>
            {showLoader && 
                <Loader />
            }
            <Breadcrumb title="Dashboard">
                <Typography variant="subtitle2" color="#8C8C8C" className="link-breadcrumb">
                Home
                </Typography>
                <Typography variant="subtitle2" className="link-breadcrumb">
                Dashboard
                </Typography>
            </Breadcrumb>
            <Grid container spacing={gridSpacing}>
                <Grid item md={8} sm={12}>
                    <Grid container spacing={gridSpacing}>
                        {data.map(elem => {
                            return (
                                <>
                                {/* {authState?.accessToken?.claims?.usergroups?.includes("ConfigToolAdmin") && */}
                                { accounts[0]?.idTokenClaims?.groups.includes("bc07e057-b44f-40df-ba4f-251acff402e8") &&
                                    <Grid item lg={6} sm={6} xs={12}>
                                        <CardComponent
                                            data={elem}
                                        />
                                    </Grid>
                                }
                                {/* }  */}
                                {/* {!authState?.accessToken?.claims?.usergroups?.includes("ConfigToolAdmin") && elem.type !== 'Mapping'  && */}
                                { !accounts[0]?.idTokenClaims?.groups.includes("bc07e057-b44f-40df-ba4f-251acff402e8") && elem.type !== 'Mapping'  &&
                                    <Grid item lg={6} sm={6} xs={12}>
                                        <CardComponent
                                            data={elem}
                                        />
                                    </Grid>
                                }  
                                </>
                            )
                        })}
                    </Grid>
                </Grid>
                <Grid item md={4} sm={6} xs={12}>
                    <Grid container spacing={gridSpacing}>
                        <Grid item lg={12} sm={12} xs={12}>
                            <ProjectComponent
                                projects={projectList}
                                footer={true}
                            />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </>
    )
}

export default Dashboard